import { createAsyncThunk } from '@reduxjs/toolkit';

import { asyncPayloadCreator } from 'utils';

import { AccountService } from 'api';

import { Login2FAProps } from 'models/api';

export const login2FA = createAsyncThunk(
	'authorization/login2Fa',
	(credentials: Login2FAProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, AccountService.login2FA),
);
